import i18n from "../../../language/i18n";

const ActivityEmptyContent = () => {
  return (
    <div className="am-empty">
      <p className="am-empty-text">
        {i18n.t("you_have_set_this_activity_as_empty")}
      </p>
    </div>
  );
};

export default ActivityEmptyContent;
